var $d71fd764236c0d12$exports = {};
$d71fd764236c0d12$exports = {
    "breadcrumbs": `Broodkruimels`
};


export {$d71fd764236c0d12$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
